<script>
import SortableTable from "@components/SortableTable.vue";
import api from "@services/api";

export default {
  extends: SortableTable,
  components: {},
  props: {
    table: {
      type: String,
      default: ""
    },
    name: {
      type: String,
      default: ""
    },
    fields: {
      type: Array,
      default: () => {
        return [];
      }
    },
    filter: {
      type: String,
      default: ""
    },
    include: {
      type: String,
      default: ""
    }
  },
  data: () => ({
    items: null,
    empty: true,
    page: 1,
    totalRows: 1,
    size: 20,
    sort: {
      sortBy: "id",
      sortOrder: "ASC"
    },
    showModalDelete: false,
    hasItems: false
  }),
  watch: {
    page: function() {
      this.getData();
    },
    size: function() {
      this.getData();
    },
    sort: function() {
      this.getData();
    }
  },
  created() {
    this.$store.dispatch("alert/clear");
    if (this.$route.query.page) {
      this.page = this.$route.query.page;
    }
    this.getData();
  },
  computed: {
    alert() {
      return this.$store.state.alert;
    }
  },
  methods: {
    getData() {
      api
        .get(`crud/${this.table}/${this.page}/${this.size}`, {
          params: {
            filter: this.filter,
            include: this.include,
            sortBy: this.sort.sortBy,
            sortOrder: this.sort.sortOrder
          }
        })
        .then(response => {
          this.items = response.data["data"];
          if (response.data["pagination"]) {
            this.page = response.data["pagination"]["pageNumber"];
            this.totalRows = response.data["pagination"]["totalRecords"];
          }
          if (
            response.data["data"] !== null &&
            response.data["data"].length > 0
          ) {
            this.hasItems = true;
          } else {
            this.hasItems = false;
          }
        });
    },
    callNew() {
      this.$router.push(
        this.$route.query.redirectFrom || {
          path: `/${this.table}/Novo`
        }
      );
    },
    callDetails(id) {
      this.$router.push(
        this.$route.query.redirectFrom || {
          path: `/${this.table}/Detalhes/${id}`
        }
      );
    },
    callDre(id) {
      this.$router.push(
        this.$route.query.redirectFrom || {
          path: `/Dre/Edit/${id}`
        }
      );
    },
    closeAlert() {
      this.$store.dispatch("alert/clear");
    }
  }
};
</script>

<template>
  <div class="card">
    <div class="card-body">
      <b-alert
        variant="danger"
        dismissible
        :show="alert.show"
        @dismissed="closeAlert"
      >
        {{ alert.message }}
      </b-alert>
      <div class="float-right mb-3">
        <b-button class="btn" variant="primary" v-on:click="callNew()">
          Cadastrar {{ name.toLowerCase() }}
        </b-button>
      </div>
      <div class="row mt-5 mb-2" v-show="!hasItems">
        <div class="col-md-12">Não foram encontrados registros.</div>
      </div>
      <div class="table-sm table" v-show="hasItems">
        <table class="table b-table table table-hover">
          <thead class="thead-primary">
            <tr>
              <!-- <th
                class="columnheader"
                scope="col"
                @click="changeSort(null, 'id', true)"
              >
                #
                <i
                  class="fas fa-sort-down ml-2"
                  v-show="showSortDown(null, 'id', true)"
                />
                <i
                  class="fas fa-sort-up ml-2"
                  v-show="showSortUp(null, 'id', true)"
                />
                <i
                  class="fas fa-sort ml-2"
                  style="color: lightgray"
                  v-show="showSortNone(null, 'id', true)"
                />
              </th> -->
              <th
                class="columnheader"
                scope="col"
                @click="changeSort(field.sortName, field.name, field.sortable)"
                v-for="field in fields"
                :key="field.name + '.' + field.type"
              >
                {{ field.description }}
                <i
                  class="fas fa-sort-down ml-2"
                  v-show="
                    showSortDown(field.sortName, field.name, field.sortable)
                  "
                />
                <i
                  class="fas fa-sort-up ml-2"
                  v-show="
                    showSortUp(field.sortName, field.name, field.sortable)
                  "
                />
                <i
                  class="fas fa-sort ml-2"
                  style="color: lightgray"
                  v-show="
                    showSortNone(field.sortName, field.name, field.sortable)
                  "
                />
              </th>
              <th></th>
            </tr>
          </thead>
          <tbody class="selected-table">
            <tr v-for="item in items" :key="item.id">
              <!-- <th scope="row">{{ item.id }}</th> -->
              <td
                v-for="field in fields"
                :key="field.name + '.' + field.type"
                @click="callDetails(item.id)"
              >
                {{ item[field.name] | formatField(field.type) }}
              </td>
              <td>
                <div class="float-right row">
                  <div class="col-md-6">
                    <b-button
                      class="btn btn-sm btn-icon"
                      variant="light"
                      v-on:click="callDre(item.id)"
                      ><i class="fe-edit"
                    /></b-button>
                  </div>
                  <div class="col-md-6">
                    <b-button
                      class="btn btn-sm btn-icon"
                      variant="primary"
                      v-on:click="callDetails(item.id)"
                      ><i class="fe-more-horizontal"
                    /></b-button>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="row" v-show="totalRows > 10">
          <div class="col-md-9 mt-1">
            <b-pagination
              v-model="page"
              pills
              :total-rows="totalRows"
              :per-page="size"
            />
          </div>
          <div class="col-md-3">
            <b-form-group
              id="size"
              label-cols-lg="7"
              label="Registros por página:"
            >
              <b-form-select v-model="size">
                <b-form-select-option value="10">10</b-form-select-option>
                <b-form-select-option value="20">20</b-form-select-option>
                <b-form-select-option value="50">50</b-form-select-option>
                <b-form-select-option value="100">100</b-form-select-option>
              </b-form-select>
            </b-form-group>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
